export type WindowSize =
  | "tiny-mobile"
  | "small-mobile"
  | "mobile"
  | "tablet"
  | "small-tablet"
  | "regular-display"
  | "large-display"
  | "small-display"
  | "extra-large-display";

export const WindowSizes = {
  tinyMobile: "tiny-mobile" as WindowSize,
  smallMobile: "small-mobile" as WindowSize,
  mobile: "mobile" as WindowSize,
  smallTablet: "small-tablet" as WindowSize,
  tablet: "tablet" as WindowSize,
  small: "small-display" as WindowSize,
  regular: "regular-display" as WindowSize,
  large: "large-display" as WindowSize,
  extraLarge: "extra-large-display" as WindowSize,
};
